<template>
  <div>
    <div class="row w-100">
      <div class="col">
        <p class="font-14">The undersigned hereby makes application for an open burning permit and certificate that the statements contained herein are true and correct.</p>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-6">
        <base-input v-model="form.signature"
                    label="Signature"
                    placeholder="Signature"
                    :validation="val.form.signature"/>
      </div>
      <div class="col-6">
        <base-input v-model="form.signatureTitle"
                    label="Title of Signer"
                    placeholder="Title"
                    :validation="val.form.signatureTitle" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col">
        <base-date-picker v-model="form.signatureDate"
                          label="Date of Signature"
                          :validation="val.form.signatureDate" />
      </div>
    </div>
    <div class="row w-100">
      <div class="col-8">
        <base-textarea v-model="form.additionalComments"
                       label="Additional Comments" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '~/components/BaseInput';
import BaseDatePicker from '~/components/BaseDatePicker';
import BaseTextarea from '~/components/BaseTexarea';

export default {
  name: 'CertificationInfo',
  props: ['form', 'val'],
  components: { BaseInput, BaseDatePicker, BaseTextarea },
  data() {
    return {
      registerUrl: '',
      loginUrl: '',
    };
  },
  mounted() {

  },
  methods: {

  },
};

</script>
